export default {
  dict: {
    DictionaryTypeCode: 'Type Code',
    DictionaryTypeName: 'Type Name',
    DictionaryType: 'Dictionary Type',
    DictInfoList: 'Dictionary Information',
    CanNotBeEmpty: 'Can not be empty',
    LengthTips: 'More than 90 characters',
    TypeSelect: 'Please choose a type'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/base/dict.js